import { Trans, useTranslation } from 'react-i18next';
import outStoryImg from '../assets/about.jpg';

const Hero = () => {
  const { t } = useTranslation();
  return (
    <section className="hero" id="about">
      <span className="section-title">
        {t('sections.about')} {t('sections.ourVision')}
      </span>
      <p>
        <Trans
          i18nKey="ourStory"
          components={{
            navigate: (
              <a
                href="https://www.cnbc.com/2019/06/28/80percent-of-the-stock-market-is-now-on-autopilot.html"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-link"
              />
            ),
          }}
        />
      </p>
      <img loading="lazy" src={outStoryImg} className="hero-img" alt="logo" />
    </section>
  );
};

export default Hero;
